import TextInputInline from './TextInputInline';

export * from './TextInputInline';

export default TextInputInline;
